import { useEffect } from 'react';

// Contador global de modais abertos
let modalCount = 0;

export function useModalOverflow() {
  useEffect(() => {
    modalCount += 1;
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      modalCount -= 1;
      if (modalCount <= 0) {
        modalCount = 0;
        document.body.style.overflow = originalOverflow;
      }
    };
  }, []);
}

/** Força reset do overflow do body — útil em caso de crash do modal */
export function resetBodyOverflow() {
  modalCount = 0;
  document.body.style.overflow = '';
}